import { render, staticRenderFns } from "./recordCopy.vue?vue&type=template&id=212e3be7&scoped=true&"
import script from "./recordCopy.vue?vue&type=script&lang=js&"
export * from "./recordCopy.vue?vue&type=script&lang=js&"
import style0 from "./recordCopy.vue?vue&type=style&index=0&id=212e3be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e3be7",
  null
  
)

export default component.exports